import { createContext, useContext } from 'react';

// Context for the entire app, persisted when viewing a single application or the list page
export const BaseContext = createContext<BaseContextValue | undefined>(undefined);

export enum SUBMISSION_TYPES {
  SUBMITTED = 'submitted',
  SHARED = 'shared',
}

export interface SubmittedApplication {
  type: SUBMISSION_TYPES;
  applicationId?: string;
  listingAlias?: string | null | undefined;
}

export interface BaseContextValue {
  submittedApplication?: SubmittedApplication;
  setSubmittedApplication?: (type?: SubmittedApplication) => void;
  brownoutWarning?: string | null;
}

export function BaseContextProvider({ children, ...value }: React.PropsWithChildren<BaseContextValue>) {
  return <BaseContext.Provider value={value}>{children}</BaseContext.Provider>;
}

export function useBaseContext() {
  const contextValue = useContext(BaseContext);
  if (!contextValue) {
    throw new Error('useBaseContext must be used within a BaseContextProvider');
  }
  return contextValue;
}
